export const redirectToDiscovery = () => {
  if (location.hostname.endsWith("localhost")) {
    window.location.assign(`http://${location.hostname}:3000/discovery` + location.search)
    return
  }
  window.location.assign("/discovery" + location.search)
}
